<template>
  <div class="sidebar" @click.stop="()=>{}">
    <div class="main-menu">
      <vue-perfect-scrollbar class="scroll" :settings="{ suppressScrollX: true, wheelPropagation: false }">
        <ul class="list-unstyled">
          <template v-for="(item) in menuItems">
            <li v-if="( item.id=='siteset' ) && basicInfo.useSite == true"
                :class="{ 'active' : (selectedParentMenu === item.id && viewingParentMenu === '') || viewingParentMenu === item.id }"
                :key="`parent_${item.id}`" :data-flag="item.id">
              <div v-if="item.userRole == 'ALL' || item.userRole==currentUseruserRole">
                <!-- {{ currentUser.userRole }} -->
                <a v-if="item.newWindow" :href="item.to" rel="noopener noreferrer" target="_blank">
                  <i :class="item.icon"/>
                  {{ $t(item.label) }}
                </a>
                <a v-else-if="item.subs && item.subs.length>0" @click.prevent="openSubMenu($event,item)"
                   :href="`#${item.to}`">
                  <i :class="item.icon"/>
                  {{ $t( item.label ) }}
                </a>
                <router-link v-else @click.native="changeSelectedParentHasNoSubmenu(item.id)" :to=toPartnerPath(item.to)>
                  <i :class="item.icon"/>
                  {{ $t(item.label) }}
                </router-link>
              </div>
            </li>
            <li v-if="item.id != 'siteset' "
                :class="{ 'active' : (selectedParentMenu === item.id && viewingParentMenu === '') || viewingParentMenu === item.id }"
                :key="`parent_${item.id}`" :data-flag="item.id">
              <div v-if="item.userRole == 'ALL' || item.userRole==currentUseruserRole">
                <!-- {{ currentUser.userRole }} -->
                <a v-if="item.newWindow" :href="item.to" rel="noopener noreferrer" target="_blank">
                  <i :class="item.icon"/>
                  {{ $t(item.label) }}
                </a>
                <a v-else-if="item.subs && item.subs.length>0" @click.prevent="openSubMenu($event,item)"
                   :href="`#${item.to}`">
                  <i :class="item.icon"/>
                  {{ $t( item.label ) }}
                </a>
                <router-link v-else @click.native="changeSelectedParentHasNoSubmenu(item.id)" :to=toPartnerPath(item.to)>
                  <i :class="item.icon"/>
                  {{ $t(item.label) }}
                </router-link>
              </div>
            </li>

          </template>

        </ul>
      </vue-perfect-scrollbar>
    </div>
    <div class="sub-menu">
      <vue-perfect-scrollbar class="scroll" :settings="{ suppressScrollX: true, wheelPropagation: false }">
        <ul v-for="(item,itemIndex) in menuItems"
            :class="{'list-unstyled':true, 'd-block' : (selectedParentMenu === item.id && viewingParentMenu === '') || viewingParentMenu === item.id }"
            :data-parent="item.id" :key="`sub_${item.id}`">
          <li v-for="(sub,subIndex) in item.subs"
              :class="{'has-sub-item' : sub.subs && sub.subs.length > 0 , 'active' : $route.path.indexOf(sub.to)>-1}" :key="subIndex">
            <a v-if="sub.newWindow" :href="sub.to" rel="noopener noreferrer" target="_blank">
              <i :class="sub.icon"/>
              <span>{{ $t(sub.label) }}</span>
            </a>
            <template v-else-if="sub.subs &&  sub.subs.length > 0">
              <b-link v-b-toggle="`menu_${itemIndex}_${subIndex}`" variant="link" class="rotate-arrow-icon opacity-50">
                <i class="simple-icon-arrow-down"></i>
                <span class="d-inline-block">{{ $t(sub.label) }}</span>
              </b-link>
              <b-collapse visible :id="`menu_${itemIndex}_${subIndex}`">
                <ul class="list-unstyled third-level-menu">
                  <li v-for="(thirdLevelSub, thirdIndex) in sub.subs"
                      :key="`third_${itemIndex}_${subIndex}_${thirdIndex}`"
                      :class="{'third-level-menu':true , 'active' : $route.path ===thirdLevelSub.to}">
                    <a v-if="thirdLevelSub.newWindow" :href="thirdLevelSub.to" rel="noopener noreferrer"
                       target="_blank">
                      <i :class="thirdLevelSub.icon"/>
                      <span>{{ $t(thirdLevelSub.label) }}</span>
                    </a>

                    <router-link v-else :to="toSitePath(thirdLevelSub.to)">
                      <i :class="thirdLevelSub.icon"/>
                      <span>{{ $t(thirdLevelSub.label) }}</span>
                    </router-link>
                  </li>
                </ul>
              </b-collapse>
            </template>

            <router-link v-else-if="item.id =='siteset'&& currentUseruserRole == 'BRAND' && sub.to=='/siteSet/AlimtalkMng' && basicInfo.useSite == true" :to="toSitePath(sub.to)">

              <i :class="sub.icon"/>
              <span>{{ $t(sub.label) }}</span>
            </router-link>
            <router-link v-else-if="item.id =='shop' && currentUseruserRole != 'BRAND' && sub.to=='/shop/AlimtalkMng' && basicInfo.useSite == true" :to="toSitePath(sub.to)">
              <i :class="sub.icon"/>
              <span>{{ $t(sub.label) }}</span>
            </router-link>
            <router-link v-else-if="sub.to!='/siteSet/AlimtalkMng' && sub.to!='/shop/AlimtalkMng'" :to="toSitePath(sub.to)">
              <i :class="sub.icon"/>
              <span>{{ $t(sub.label) }}</span>
            </router-link>

<!--              <template v-else-if="sub.to!='/siteSet/AlimtalkMng'">-->
<!--                <i :class="sub.icon"/>-->
<!--                <span>{{ $t(sub.label) }}</span>-->
<!--              </template>-->
<!--            </router-link>-->
          </li>
        </ul>
      </vue-perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations
} from "vuex";
import {
  menuHiddenBreakpoint,
  subHiddenBreakpoint
} from "../constants/config";
import menuItems from "../constants/menu";
import api from "@/constants/api";

export default {
  data() {
    return {
      selectedParentMenu: "",
      menuItems,
      viewingParentMenu: "",
      currentUseruserRole : '',
      basicInfo:{},
      siteInfo:{},

    };
  },
  mounted() {

    this.currentUseruserRole = this.currentUser.userRole.split('_')[0] !== null ? this.currentUser.userRole.split('_')[0] : 'no';
    if(navigator.userAgent.match(/Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)){
      this.selectMenu();
    }else{
      window.addEventListener("resize", this.handleWindowResize);
      document.addEventListener("click", this.handleDocumentClick);
      this.selectMenu();
      this.handleWindowResize();
    }
  this.getInfo();

  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick);
    window.removeEventListener("resize", this.handleWindowResize);
  },

  methods: {
    ...mapMutations([
      "changeSideMenuStatus",
      "addMenuClassname",
      "changeSelectedMenuHasSubItems"
    ]),
    selectMenu() {
      const currentParentUrl = this.$route.path
        .split("/")
        .filter(x => x !== "")[1];
      if(currentParentUrl !== undefined || currentParentUrl !== null) {
        this.selectedParentMenu = currentParentUrl.toLowerCase();
      } else {
        this.selectedParentMenu = "dashboards";
      }
      this.isCurrentMenuHasSubItem();
    },
    isCurrentMenuHasSubItem() {
      const menuItem = this.menuItems.find(
        x => x.id === this.selectedParentMenu
      );
      const isCurrentMenuHasSubItem =
        menuItem && menuItem.subs && menuItem.subs.length > 0 ? true : false;
      if(isCurrentMenuHasSubItem != this.selectedMenuHasSubItems) {
        if(!isCurrentMenuHasSubItem) {
          this.changeSideMenuStatus({
            step: 0,
            classNames: this.menuType,
            selectedMenuHasSubItems: false
          });
        }
      }

      return isCurrentMenuHasSubItem;
    },

    changeSelectedParentHasNoSubmenu(parentMenu) {
      this.selectedParentMenu = parentMenu;
      this.viewingParentMenu = parentMenu;
      this.changeSelectedMenuHasSubItems(false);
      this.changeSideMenuStatus({
        step: 0,
        classNames: this.menuType,
        selectedMenuHasSubItems: false
      });
    },

    openSubMenu(e, menuItem) {
      const selectedParent = menuItem.id;
      const hasSubMenu = menuItem.subs && menuItem.subs.length > 0;
      this.changeSelectedMenuHasSubItems(hasSubMenu);
      if(!hasSubMenu) {
        this.viewingParentMenu = selectedParent;
        this.selectedParentMenu = selectedParent;
        this.toggle();
      } else {
        const currentClasses = this.menuType ?
          this.menuType.split(" ").filter(x => x !== "") :
          "";

        if(!currentClasses.includes("menu-mobile")) {
          if(
            currentClasses.includes("menu-sub-hidden") &&
            (this.menuClickCount === 2 || this.menuClickCount === 0)
          ) {
            this.changeSideMenuStatus({
              step: 3,
              classNames: this.menuType,
              selectedMenuHasSubItems: hasSubMenu
            });
          } else if(
            currentClasses.includes("menu-hidden") &&
            (this.menuClickCount === 1 || this.menuClickCount === 3)
          ) {
            this.changeSideMenuStatus({
              step: 2,
              classNames: this.menuType,
              selectedMenuHasSubItems: hasSubMenu
            });
          } else if(
            currentClasses.includes("menu-default") &&
            !currentClasses.includes("menu-sub-hidden") &&
            (this.menuClickCount === 1 || this.menuClickCount === 3)
          ) {
            this.changeSideMenuStatus({
              step: 0,
              classNames: this.menuType,
              selectedMenuHasSubItems: hasSubMenu
            });
          }
        } else {
          this.addMenuClassname({
            classname: "sub-show-temporary",
            currentClasses: this.menuType
          });
        }
        this.viewingParentMenu = selectedParent;
      }
    },
    handleDocumentClick(e) {
      this.viewingParentMenu = "";
      this.selectMenu();
      this.toggle();
    },
    toggle() {
      const currentClasses = this.menuType.split(" ").filter(x => x !== "");
      if(
        currentClasses.includes("menu-sub-hidden") &&
        this.menuClickCount === 3
      ) {
        this.changeSideMenuStatus({
          step: 2,
          classNames: this.menuType,
          selectedMenuHasSubItems: this.selectedMenuHasSubItems
        });
      } else if(
        currentClasses.includes("menu-hidden") ||
        currentClasses.includes("menu-mobile")
      ) {
        if(!(this.menuClickCount === 1 && !this.selectedMenuHasSubItems)) {
          this.changeSideMenuStatus({
            step: 0,
            classNames: this.menuType,
            selectedMenuHasSubItems: this.selectedMenuHasSubItems
          });
        }
      }
    },
    handleWindowResize(event) {
      if(event && !event.isTrusted) {
        return;
      }
      let nextClasses = this.getMenuClassesForResize(this.menuType);
      this.changeSideMenuStatus({
        step: 0,
        classNames: nextClasses.join(" "),
        selectedMenuHasSubItems: this.selectedMenuHasSubItems
      });
    },
    getMenuClassesForResize(classes) {
      let nextClasses = classes.split(" ").filter(x => x !== "");
      const windowWidth = window.innerWidth;

      if(windowWidth < menuHiddenBreakpoint) {
        nextClasses.push("menu-mobile");
      } else if(windowWidth < subHiddenBreakpoint) {
        nextClasses = nextClasses.filter(x => x !== "menu-mobile");
        if(
          nextClasses.includes("menu-default") &&
          !nextClasses.includes("menu-sub-hidden")
        ) {
          nextClasses.push("menu-sub-hidden");
        }
      } else {
        nextClasses = nextClasses.filter(x => x !== "menu-mobile");
        if(
          nextClasses.includes("menu-default") &&
          nextClasses.includes("menu-sub-hidden")
        ) {
          nextClasses = nextClasses.filter(x => x !== "menu-sub-hidden");
        }
      }
      return nextClasses;
    },
    toSitePath(pathTo) {
      //
      // .log(this.$route.params.sitename+pathTo)
      return "/" + this.$route.params.sitename + pathTo;
    },
    getInfo(){
      let reqURL = ''

      reqURL = api.changeAPI(this.$route.params.sitename, api.basicURL + api.alimtalkMng.getBrandInfo)

      const params =
        {"site_name": this.$route.params.sitename}

      this.$http.get(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        // ;
        if (res.data.code === "OK") {

          this.basicInfo = res.data.data.basicInfo
          this.siteInfo = res.data.data.siteInfo

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);

      })

    },

  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      menuType: "getMenuType",
      menuClickCount: "getMenuClickCount",
      selectedMenuHasSubItems: "getSelectedMenuHasSubItems"
    })
  },
  watch: {
    currentUser(val) {
    },


    $route(to, from) {
      if(to.path !== from.path) {
        const toParentUrl = to.path.split("/").filter(x => x !== "")[1];
        if(toParentUrl !== undefined || toParentUrl !== null) {
          this.selectedParentMenu = toParentUrl.toLowerCase();
        } else {
          this.selectedParentMenu = "dashboards";
        }

        this.selectMenu();
        this.toggle();
        this.changeSideMenuStatus({
          step: 0,
          classNames: this.menuType,
          selectedMenuHasSubItems: this.selectedMenuHasSubItems
        });

        window.scrollTo(0, top);
      }
    }
  }
};
</script>
